import React, { useState, useEffect, useCallback } from 'react';
import { getAllPages, updatePage } from '../../api';
import '../../styles/AdminStyles.css';

const PagesAdmin = () => {
  const [pages, setPages] = useState([]);
  const [selectedSlug, setSelectedSlug] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const fetchPages = useCallback(async () => {
    try {
      const data = await getAllPages();
      setPages(data);
      if (data.length > 0 && !selectedSlug) {
        setSelectedSlug(data[0].slug);
        setTitle(data[0].title);
        setContent(data[0].content);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [selectedSlug]); // зависит от selectedSlug, чтобы избежать лишних вызовов

  useEffect(() => {
    fetchPages();
  }, [fetchPages]);

  const handlePageChange = (slug) => {
    const page = pages.find(p => p.slug === slug);
    if (page) {
      setSelectedSlug(slug);
      setTitle(page.title);
      setContent(page.content);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await updatePage(selectedSlug, { title, content });
      alert('Страница сохранена');
      fetchPages(); // обновить список
    } catch (err) {
      console.error(err);
      alert('Ошибка сохранения');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loading-spinner">Загрузка...</div>;

  return (
    <div className="admin-wrapper">
      <div className="admin-header">
        <h1 className="admin-title">Управление страницами</h1>
        <button onClick={() => window.location.href = '/admin'} className="admin-logout-btn">Назад</button>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">Выберите страницу</div>
        <select value={selectedSlug} onChange={(e) => handlePageChange(e.target.value)} className="admin-form-row">
          {pages.map(page => (
            <option key={page.slug} value={page.slug}>{page.title}</option>
          ))}
        </select>
      </div>

      <div className="admin-card">
        <div className="admin-card-header">Редактирование: {pages.find(p => p.slug === selectedSlug)?.title}</div>
        <div className="admin-form">
          <div className="admin-form-row">
            <label>Заголовок</label>
            <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} />
          </div>
          <div className="admin-form-row">
            <label>Содержание (HTML)</label>
            <textarea value={content} onChange={(e) => setContent(e.target.value)} rows="20" style={{ fontFamily: 'monospace' }} />
          </div>
          <button onClick={handleSave} className="admin-btn admin-btn-primary" disabled={saving}>
            {saving ? 'Сохранение...' : 'Сохранить'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PagesAdmin;